export const otherModule = {
  loadingPay: "지불 결과 가져오는 중",
  goDetail: "주문서 추가 정보"
};
